import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice, InvoiceSource } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ArrowCornerIcon } from "@icons";
import { getInvoiceUrl, getInvoiceUrlTitle } from "@helpers/invoice";
import { useOverlays } from "contexts/OverlayContext";

export const ExternalLinkCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, unknown>) => {
        const { openOverlay } = useOverlays();
        const invoice = row.original;
        const isNativeInvoice = invoice.source === InvoiceSource.MANUAL;

        if (isNativeInvoice) {
            return (
                <ViewTableCell captureClicks>
                    <Tooltip content="View invoice">
                        <Button
                            size="sm"
                            iconOnly
                            variant="secondary"
                            aria-label="View invoice"
                            onClick={(e) => {
                                e.stopPropagation();
                                openOverlay("nativeInvoiceDrawer", {
                                    invoiceId: invoice.id,
                                });
                            }}
                        >
                            <ArrowCornerIcon />
                        </Button>
                    </Tooltip>
                </ViewTableCell>
            );
        }

        const url = getInvoiceUrl(invoice);

        if (!url) {
            return <ViewTableCell />;
        }

        const invoiceUrlTitle = getInvoiceUrlTitle(invoice);

        return (
            <ViewTableCell captureClicks>
                <Tooltip content={invoiceUrlTitle}>
                    <Button
                        size="sm"
                        iconOnly
                        variant="secondary"
                        aria-label={invoiceUrlTitle || "Open invoice"}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(url, "_blank", "noopener,noreferrer");
                        }}
                    >
                        <ArrowCornerIcon />
                    </Button>
                </Tooltip>
            </ViewTableCell>
        );
    },
);
